// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import React from 'react'
import useScreenSize from './useScreenSize'
import useWindowDimensions from './useWindowDimensions'


interface ISectionDimensions {
  contentClasses: string[]
  height: number
  isFullscreen: boolean
  containerStyle: React.CSSProperties,
  width: number
}


interface SectionDimensionOptions {
  withMenu?: boolean
}



const useSectionDimensions: (opts?: SectionDimensionOptions) => ISectionDimensions = (opts) => {
  const config: SectionDimensionOptions = opts || {}
  const {height, width} = useWindowDimensions()
  const contentClasses = ["section-content"]
  const contentHeight = `calc(${height}px - var(--offset-top) - var(--offset-bottom) - var(--page-header-height))`
  const isFullScreen = useScreenSize()
  if (!!isFullScreen) {
    contentClasses.push("fullscreen")
  }
  return {
    containerStyle: {
      "--panel-padding": (!!isFullScreen) ? "24px" : "11px",
      "--section-header-height": "48px",
      "--section-content-height": contentHeight,
      "--section-padding": (!!isFullScreen) ? "24px" : "11px",
      height: contentHeight,
    },
    contentClasses,
    height: height,
    isFullscreen: isFullScreen,
    width: width
  }
}

export {
    useSectionDimensions,
}